import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className"];
import { cn } from "../utils";

// TODO: Isn't animate-pulse a better loading animation?

/**
 * @deprecated Use `@crehana/compass.ui/v3/skeleton` instead. The v3 Skeleton
 * is a compound primitive (`Skeleton.Avatar` / `.Text` / `.Block`) with
 * layer-aware shimmer (01 for white surfaces, 02 for the canvas gray-10),
 * `prefers-reduced-motion` fallback, and a polymorphic Block via Base UI
 * `useRender`. This v2 version is kept only for backward compatibility and
 * will be removed in a future major release.
 */
import { jsx as _jsx } from "react/jsx-runtime";
function Skeleton(_ref) {
  var className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx("div", _objectSpread({
    className: cn('tw-skeleton tw-relative tw-flex tw-overflow-hidden tw-rounded-1 tw-bg-neutral-light-400 dark:tw-bg-neutral-dark-600', className)
  }, props));
}
export { Skeleton };